module.exports = __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLEj6Z1JlFd2JQEl8qw.72b3ae37.woff2";